import { http } from '@pequity/shared/axios/http';
import { useTokenInterceptors } from '@/axios/interceptors';

export const setupAxiosInterceptors = () => {
  useTokenInterceptors(http);
};
